<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/bj_03.jpg" alt="">
        </div>
        <div class="Certification_System">
            <div class="Certification_System_box">
                <div class="System_box_1">
                    <div class="System_box_1_left">
                        <p class="System_box_1_left_1 " @click="onSystem">Certification System</p>
                        <p class="System_box_1_left_1" @click="onOfficers">Certification Officers</p>
                        <p class="System_box_1_left_1 active">Certificate Search</p>
                    </div>
                    <div class="System_box_1_right" style="padding-bottom:100px;" v-if="!isshow&&data.length==0">
                        <p class="search_1" style="padding-bottom:40px !important;">Please enter your inquiry
                            information</p>
                        <p class="search_title">Name</p>
                        <el-input style="width:800px;" v-model="certNo" placeholder="Please fill in your name">
                        </el-input>
                        <p class="search_title" style="margin-top:20px;">ID Number</p>
                        <el-input style="width:800px;" v-model="idCard" placeholder="Please fill in your ID Number!">
                        </el-input>
                        <br />
                        <el-button class="search_button" type="primary" @click="onsubmit">Search</el-button>
                    </div>
                    <!-- 没查到 -->
                    <div v-if="isshow" class="System_box_1_right_2_j">
                        <div class="right_2_j_1">Your certificate was not found</div>
                        <el-button class="right_2_j_2" @click="isshow=false"> return search </el-button>
                    </div>
                    <!-- 查到了 -->
                    <div v-if="data.length!=0" class="System_box_1_right">
                        <div v-for="(item,index) in data" :key="index">
                            <img :src="item.certPhoto" alt="">
                        </div>
                        <div style="display: flex;justify-content:space-between;">
                            <el-button style="margin-top: 20px;" class="right_2_j_2" @click="downloadCertificate">
                                Download the
                                certificate picture </el-button>
                            <el-button style="margin-top: 20px;" class="right_2_j_2" @click="qingkong">
                                return search </el-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                certNo: "",
                idCard: "",
                isshow: false,
                data: [],
            }
        },
        components: {},

        //方法集合
        methods: {
            async downloadCertificate() {
                const downloadPromises = this.data.map(async (cert, index) => {
                    try {
                        const response = await fetch(cert.certPhoto);
                        if (!response.ok) {
                            throw new Error(`Failed to fetch image at ${cert.certPhoto}`);
                        }
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // 设置下载的文件名，这里使用索引和默认扩展名，你也可以根据需要自定义文件名  
                        a.download = `certificate_${index + 1}.jpg`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url); // 释放 URL 对象  
                    } catch (error) {
                        console.error(`Error downloading ${cert.certPhoto}:`, error);
                        // 可以在这里添加额外的错误处理逻辑，比如通知用户下载失败  
                    }
                });

                // 等待所有下载操作完成（注意：这里的等待只是等待 fetch 和后续操作的 Promise 完成，  
                // 并不能保证所有文件都已经完全下载到用户的设备上，因为下载是异步的并且由浏览器控制）  
                try {
                    await Promise.all(downloadPromises);
                } catch (error) {
                    // 处理 Promise.all 中的错误（理论上这里不太可能会捕获到错误，因为每个下载操作都有自己的错误处理）  
                    console.error('An error occurred while downloading certificates:', error);
                }
            },
            qingkong() {
                this.data = []
                this.keywords = "",
                    this.idCard = ""
            },
            // 搜索按钮
            onsubmit() {
                if (this.certNo == '' && this.idCard == '') {
                    this.$message('The system is busy. Please try again later.');
                } else {
                    this.certlist()
                }
            },
            // 搜索接口
            certlist() {
                var _this = this;
                _this.$api.certlist({
                    keywords: _this.certNo,
                    idCard: _this.idCard,
                    certCode: "isfal"
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        if (res.data.list.length == 0) {
                            this.isshow = true
                        }
                        _this.data = res.data.list
                    } else {
                        // _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    // _this.$message.error(error.msg);
                });
            },
            onSystem() {
                this.$router.push('/Certification_System')
            },
            onOfficers() {
                this.$router.push('/Certification_Officers')
            },
            onSearch() {
                this.$router.push('/Certificate_Search')
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>
<style scoped>

</style>